import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const fileUrl = (path) => `${API_BASE}/files/${path}`;

export const fmt = (v, cur = "SEK") =>
  `${Number(v || 0).toLocaleString("sv-SE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${cur}`;

export const fmtNum = (v) =>
  Number(v || 0).toLocaleString("sv-SE", { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export function apiErr(e, fallback = "Något gick fel") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || fallback;
}

export const today = () => new Date().toISOString().slice(0, 10);
export function monthStart() {
  const d = new Date();
  return new Date(d.getFullYear(), d.getMonth(), 1).toISOString().slice(0, 10);
}
